export function formatMinutesDuration(minutes: number): string {
  const totalSeconds = Math.round(minutes * 60);
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;

  if (mins === 0) {
    return `${secs}s`;
  }

  if (secs === 0) {
    return `${mins}m`;
  }

  return `${mins}m ${secs}s`;
}

export function formatMinutesAxisTick(minutes: number): string {
  if (minutes === 0) {
    return "0";
  }

  return `${minutes}m`;
}
